import * as React from 'react';
import * as styles from './styles.css';

import { Button, UIHeading1, UIText1 } from '@cian/ui-kit';
import { reloadPage } from '@cian/valuation-utils-component';

export function ErrorResult() {
  return (
    <div className={styles['container']} data-testid="market_price_error">
      <div className={styles['title']}>
        <UIHeading1 textAlign={'center'}>Что-то пошло не так</UIHeading1>
      </div>
      <div className={styles['content']}>
        <UIText1 textAlign={'center'}>Обновите страницу. Если ничего не изменилось, повторите попытку позже</UIText1>
      </div>
      <div className={styles['button']}>
        <Button onClick={reloadPage}>Обновить страницу</Button>
      </div>
    </div>
  );
}
